// extracted by mini-css-extract-plugin
export default {"innerFooter":"InnerFooter_innerFooter__WllOy"};